// extracted by mini-css-extract-plugin
export var container = "Testimonials-module--container--9e735";
export var testimonial = "Testimonials-module--testimonial--e99ea";